import { useTranslation } from "react-i18next";
import { ValueName } from "../../ValueName";
import { UNASSIGNED_AXIS_KEY } from "../constants";
import type { TableHeaderRowProps } from "./types";

export const TableHeaderRow = ({ table }: TableHeaderRowProps) => {
  const { t } = useTranslation();

  const { rows, columns } = table;

  return (
    // The transparent side borders match the 1px border of the card rows below.
    <div className="sticky top-0 z-10 col-span-full grid grid-cols-subgrid items-start border border-transparent border-b-gray-200 bg-white py-2.5 text-xs font-medium uppercase leading-5 tracking-wide text-gray-500">
      {rows.key !== null && (
        <span className="px-3">
          {t("smartSurveyor.folders.suggestion.level")}
        </span>
      )}
      {columns.values.map((columnValue) => (
        <ValueName
          key={columnValue?.code ?? UNASSIGNED_AXIS_KEY}
          fileCode={columnValue?.fileCode ?? null}
          name={
            columns.key === null
              ? t("smartSurveyor.common.plans")
              : (columnValue?.name ??
                t("smartSurveyor.folders.suggestion.notAssigned"))
          }
          className="px-3 text-sm font-semibold normal-case tracking-normal text-gray-700"
        />
      ))}
    </div>
  );
};
